<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link :to="`/admin/users?page=${page}`">ユーザー一覧</router-link></li>
                <li class="breadcrumb-item">ユーザー</li>
            </ol>
        </nav>
        <div class="container">
            <div class="user" :class="{deleted: user.deleted_at}" v-if="user.id">
                <div class="mb-3">
                    <label>ユーザ名</label>
                    <div class="param justify-content-between d-flex">
                        <div>
                            <h4>
                                <ruby>{{user.name}}<rt>{{user.kana}}</rt></ruby>
                            </h4>
                            <div class="d-flex justify-content-start">
                                <div class="mr-3">
                                    <span class="badge badge-danger badge-pill" v-if="user.is_root">管理者</span>
                                    ID: {{this.$route.params.id}}
                                </div>
                                <div v-if="user.is_prohibited" class="text-danger">
                                    <i class="fas fa-user-lock"></i>
                                    制限ユーザー
                                </div>
                            </div>
                        </div>
                        <div>
                            <button type="button" class="btn btn-outline-warning" @click="impersonate()">
                                <i class="fas fa-user-secret"></i>
                                なりすまし
                            </button>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label>メールアドレス</label>
                    <div class="param d-flex justify-content-between">
                        <div>
                            {{user.email}}
                            <span v-if="user.email_verified_at" class="badge badge-success badge-pill">承認済み</span>
                            <span v-else class="badge badge-danger badge-pill">未承認</span>
                        </div>
                        <div>
                            <div v-if="!user.email_verified_at">
                                <button class="btn btn-outline-success" @click="verifyEmail()" :disabled="user.email.match(/^guest-[^@]+$/)">
                                    <i class="fas fa-user-check"></i>
                                    手動承認する
                                </button>
                            </div>
                            <div v-if="user.is_prohibited">
                                <button class="btn btn-outline-secondary" @click="permitUser()">
                                    <i class="fas fa-lock-open"></i>
                                    制限を解除する
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label>ドメイン</label>
                    <div class="param">
                        <a :href="hondana" v-if="user.subdomain">{{user.subdomain}}</a>
                        <span v-else>-</span>
                        <div v-if="user.subdomains">
                            <div>
                                旧ドメイン
                            </div>
                            <ul>
                                <li v-for="sd in user.subdomains" :key="sd.id">
                                    {{sd.subdomain}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label>Twitter</label>
                    <div class="param">
                        <a :href="`https://x.com/${user.twitter}`" target="_blank" v-if="user.twitter" class="btn btn-primary btn-sm">
                            <i class="fab fa-twitter"></i>
                            @{{user.twitter}}
                            <i class="fas fa-external-link-alt"></i>
                        </a>
                        <span v-else>-</span>
                    </div>
                </div>
                <div class="mb-3">
                    <label>自己紹介</label>
                    <div class="param" v-html="$filters.wrap(user.profile || '-')">
                    </div>
                </div>
                <div class="mb-3">
                    <label>小説</label>
                    <div class="param">
                        <div class="list-group" v-if="user.books.length">
                            <a :href="url(b)" traget="_blank" v-for="b in user.books" :key="b.id">
                                {{b.title}}
                                <i class="fas fa-eye-slash" v-if="b.is_hidden"></i>
                                <span class="badge badge-danger" v-if="!b.property.first_published_at">未公開</span>
                            </a>
                        </div>
                        <div v-else>-</div>
                    </div>
                </div>
                <div class="mb-3">
                    <label>表示設定</label>
                    <div class="param">
                        <div class="row">
                            <div class="col-md">
                                <label>文字サイズ</label>
                                <div class="value">
                                    <span v-if="user.font_size == 1">小</span>
                                    <span v-if="user.font_size == 2">中</span>
                                    <span v-if="user.font_size == 3">大</span>
                                    <span v-if="user.font_size == 4">特大</span>
                                </div>
                            </div>
                            <div class="col-md">
                                <label>背景色</label>
                                <div class="value">
                                    <span v-if="user.background_color == 'white'">白</span>
                                    <span v-if="user.background_color == 'black'">黒</span>
                                    <span v-if="user.background_color == 'zouge'">象牙</span>
                                    <span v-if="user.background_color == 'sakura'">桜</span>
                                    <span v-if="user.background_color == 'dreamy'">ゆめいろ</span>
                                    <span v-if="user.background_color == 'forest'">森林</span>
                                    <span v-if="user.background_color == 'cosmo'">ラベンダー</span>
                                    <span v-if="user.background_color == 'metal'">金属</span>
                                    <span v-if="user.background_color == 'doom'">闇夜</span>
                                    <span v-if="user.background_color == 'rome'">ワイン</span>
                                    <span v-if="user.background_color == 'jupiter'">木星</span>
                                    <span v-if="user.background_color == 'space'">宇宙</span>
                                </div>
                            </div>
                            <div class="col-md">
                                <label>フォント</label>
                                <div class="value">
                                    <span v-if="user.font == 'gothic'">ゴシック</span>
                                    <span v-if="user.font == 'mincho'">明朝</span>
                                    <span v-if="user.font == 'ud'">UD明朝</span>
                                    <span v-if="user.font == 'kaisei'">解星デコール</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md">
                                <label>組み方向</label>
                                <div class="value">
                                    <span v-if="user.is_horizontal">横書き</span>
                                    <span v-if="!user.is_horizontal">縦書き</span>
                                </div>
                            </div>
                            <div class="col-md">
                                <label>出力</label>
                                <div class="value">
                                    <span v-if="user.output_style == 0">全部</span>
                                    <span v-if="user.output_style == 1">ゆっくり</span>
                                    <span v-if="user.output_style == 2">通常</span>
                                    <span v-if="user.output_style == 3">高速</span>
                                </div>
                            </div>
                            <div class="col-md">
                                <label>SE</label>
                                <div class="value">
                                    <span v-if="user.sound_effect == 0">なし</span>
                                    <span v-if="user.sound_effect == 1">SE1</span>
                                    <span v-if="user.sound_effect == 2">SE2</span>
                                    <span v-if="user.sound_effect == 3">SE3</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label>内部しきい値</label>
                    <div class="param">
                        <div class="row mb-3">
                            <div class="col-md">
                                <label>作品最大数</label>
                                <input type="number" class="form-control nospin" v-model="user.novel_limit">
                            </div>
                            <div class="col-md">
                                <label>最大エピソード数</label>
                                <input type="number" class="form-control nospin" v-model="user.episode_limit">
                            </div>
                            <div class="col-md">
                                <label>最大記事数</label>
                                <input type="number" class="form-control nospin" v-model="user.article_limit">
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md">
                                <label>ストレージ</label>
                                <div class="input-group dropdown">
                                    <input type="number" class="form-control nospin dropdown-toggle" data-toggle="dropdown" v-model="user.storage_limit">
                                    <div class="input-group-append">
                                        <span class="input-group-text">
                                            {{ $filters.getByte(user.storage_limit) }}
                                        </span>
                                    </div>
                                    <div class="dropdown-menu">
                                        <a href="#" class="dropdown-item" @click.prevent="user.storage_limit = '5242880'">5MB</a>
                                        <a href="#" class="dropdown-item" @click.prevent="user.storage_limit = '10485760'">10MB</a>
                                        <a href="#" class="dropdown-item" @click.prevent="user.storage_limit = '20971520'">20MB</a>
                                        <a href="#" class="dropdown-item" @click.prevent="user.storage_limit = '31457280'">30MB</a>
                                        <a href="#" class="dropdown-item" @click.prevent="user.storage_limit = '104857600'">100MB</a>
                                        <a href="#" class="dropdown-item" @click.prevent="user.storage_limit = '209715200'">200MB</a>
                                        <a href="#" class="dropdown-item" @click.prevent="user.storage_limit = '314572800'">300MB</a>
                                        <a href="#" class="dropdown-item" @click.prevent="user.storage_limit = '524288000'">500MB</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button class="btn btn-outline-primary" @click="save()">
                                <i class="fas fa-save"></i>
                                更新
                            </button>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label>ステータス</label>
                    <div class="param">
                        <div v-if="user.deleted_at" class="d-flex justify-content-between">
                            <div class="p-">
                                {{$filters.fromNow(user.deleted_at )}} ( {{$filters.dateFormat(user.deleted_at)}} ) に退会済み
                            </div>
                            <button type="button" class="btn btn-outline-success" @click="restore()">
                                <i class="fas fa-trash-restore"></i>
                                退会を取り消す
                            </button>
                        </div>
                        <div v-else  class="d-flex justify-content-between">
                            <div class="p-1">
                                {{$filters.fromNow(user.made_at )}} ( {{$filters.dateFormat(user.made_at)}} ) にアクセス
                            </div>
                            <button type="button" class="btn btn-outline-danger" @click="resign()">
                                <i class="fas fa-skull-crossbones"></i>
                                強制退会
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<style scoped lang="scss">
.user {
    max-width: 640px;
    margin: 1rem auto;
    label {
        margin: 1rem 0 0;
        padding: .5rem 1rem;
        background-color: #bbb;
        color: #222;
        font-weight: bold;
        border-radius: .7rem .7rem 0 0;
    }
    .param {
        margin: 0 0 .5rem;
        padding: 1rem;
        border: 2px solid #bbb;
        border-radius: 0 .7rem .7rem .7rem;
        label {
            font-weight: bold;
        }
        .value {
            padding: .5rem;
            border: 1px solid #bbb;
            border-radius: 0 .5rem .5rem .5rem;
        }
    }
}
.deleted {
    color: #999;
}
</style>

<script>
export default {
    data() {
        return {
            user: {},
            page: parseInt(this.$route.query.page) || 1,
            isLoading: false,
        }
    },
    methods: {
        load() {
            this.isLoading = true;
            axios.get("/admin/user/get", {params: {id: this.$route.params.id}}).then(res => {
                this.user = res.data;
                this.isLoading = false;
            }).catch(err => { alert.err(err.response) });
        },
        restore() {
            Swal.fire({
                title: "復帰",
                text: "ユーザを復帰します。よろしいですか？",
                icon: "info",
                showCancelButton: true,
                confirmButtonText: "復帰する",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "royalblue",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/admin/user/restore", {id: this.$route.params.id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    }).catch(err => { alert.err(err.response) });
                }
            });
        },
        resign() {
            Swal.fire({
                title: "強制退会",
                text: "ユーザを強制退会します。よろしいですか？",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "退会させる",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/admin/user/resign", {id: this.$route.params.id}).then(res => {
                        alert.msg(res.data);
                        this.load();
                    }).catch(err => { alert.err(err.response) });
                }
            });
        },
        save() {
            axios.post("/admin/user/save", this.user).then(res => {
                alert.msg("しきい値を保存しました。");
                this.load();
            }).catch(err => { alert.err(err.response) });
        },
        url(b) {
            return "//" + this.user.subdomain + this.$store.state.base_domain + "/author/book/" + b.id;
        },
        impersonate() {
            axios.post("/admin/impersonate", {id: this.$route.params.id}).then(res => {
                location.href = "/";
            }).catch(err => { alert.err(err.response) });
        },
        verifyEmail() {
            axios.post("/admin/user/verify", {id: this.user.id}).then(res => {
                alert.msg("メールアドレスを承認しました。");
                this.load();
            }).catch(err => { alert.err(err.response) });
        },
        permitUser() {
            axios.post("/admin/user/permit", {id: this.user.id}).then(res => {
                alert.msg("制限を解除しました。");
                this.load();
            }).catch(err => { alert.err(err.response) });
        },
    },
    computed: {
        hondana() {
            return "//" + this.user.subdomain + this.$store.state.base_domain;
        },
    },
    mounted() {
        this.load();
    }
}
</script>